<template>
  <BModal
    :width="1253"
    :active="show"
    trap-focus
    :destroy-on-hide="false"
    aria-role="dialog"
    aria-modal
    :can-cancel="['outside', 'escape']"
    @close="$emit('close')"
  >
    <div class="lives-modal-container">
      <div class="modal-player-mobile-sm screen">
        <div class="info-container">
          <h1 class="title valign-text-middle avenirnextltpro-regular-normal-black-32px">
            <span
              ><span class="title-320-header avenirnextltpro-regular-normal-black-32px">Player</span
              ><span class="subtitle-320-header avenirnextltpro-regular-normal-black-32px"> Info</span>
            </span>
          </h1>
          <div class="info-categories">
            <div class="info-categories-item">
              <div class="nombre valign-text-middle avenirnextltpro-regular-normal-nevada-16px">Nombre:</div>
              <div class="gignac-andre-pierre-320 valign-text-middle avenirnextltpro-bold-black-19px">
                {{ playerName }}
              </div>
            </div>
            <img
              class="horizontal-div"
              src="https://anima-uploads.s3.amazonaws.com/projects/6422323e6ab4691decea8c0b/releases/64223b75874359aba14242aa/img/horizontal-div@2x.png"
              alt="horizontal-div"
            />
            <div class="info-categories-item">
              <div class="nombre valign-text-middle avenirnextltpro-regular-normal-nevada-16px">Posición:</div>
              <div class="gignac-andre-pierre-320 valign-text-middle avenirnextltpro-bold-black-19px">
                {{ playerPosition }}
              </div>
            </div>
            <img
              class="horizontal-div"
              src="https://anima-uploads.s3.amazonaws.com/projects/6422323e6ab4691decea8c0b/releases/64223b75874359aba14242aa/img/horizontal-div@2x.png"
              alt="horizontal-div"
            />
            <div class="info-categories-item">
              <div class="nombre valign-text-middle avenirnextltpro-regular-normal-nevada-16px">Partidos jugados:</div>
              <div class="gignac-andre-pierre-320 valign-text-middle avenirnextltpro-bold-black-19px">
                {{ player.games_played }}
              </div>
            </div>
            <img
              class="horizontal-div"
              src="https://anima-uploads.s3.amazonaws.com/projects/6422323e6ab4691decea8c0b/releases/64223b75874359aba14242aa/img/horizontal-div@2x.png"
              alt="horizontal-div"
            />
            <div class="info-categories-item">
              <div class="nombre valign-text-middle avenirnextltpro-regular-normal-nevada-16px">Minutos jugados:</div>
              <div class="gignac-andre-pierre-320 valign-text-middle avenirnextltpro-bold-black-19px">
                {{ player.minutes_played }}
              </div>
            </div>
            <img
              class="horizontal-div"
              src="https://anima-uploads.s3.amazonaws.com/projects/6422323e6ab4691decea8c0b/releases/64223b75874359aba14242aa/img/horizontal-div@2x.png"
              alt="horizontal-div"
            />
            <div class="info-categories-item">
              <div class="nombre valign-text-middle avenirnextltpro-regular-normal-nevada-16px">Torneo:</div>
              <div style="line-height: 1.1" class="gignac-andre-pierre-320 valign-text-middle avenirnextltpro-bold-black-19px">
                {{ nameSeasonSelected }}
              </div>
            </div>
          </div>
        </div>
        <div class="close-btn" @click="closeModal">
          <div class="acertar">Cerrar</div>
        </div>
      </div>
    </div>
  </BModal>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import playerHeaderMixin from '@/utils/mixins/player-header';
import { BModal } from 'buefy/dist/esm/modal';
export default {
  name: 'Lives',
  components: {
    BModal,
  },
  computed: {
    ...mapGetters('loginGeneral', ['getTournamentsNameSelected', 'getSeasonsNameSelected']),
    ...mapState('filterGeneral', [
      'seasons',
      'hasPlayerNationalTeam',
      'isPlayerNationalTeam',
      'nationalSeasons',
      'hasPlayerClubSeasons',
    ]),
    ...mapGetters('filterGeneral', {
      seasonId: 'getSeasonId',
    }),
  },
  data() {
    return {
      nameSeasonSelected: '',
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    player: {
      type: Object,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
  watch: {
    player: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue) {
          const selectedSeason = this.seasons.find(season => season.id === this.seasonId);
          if (this.isPlayerNationalTeam) {
            const nationalSeason = newValue.national_seasons[selectedSeason.id];
            this.nameSeasonSelected = nationalSeason ? nationalSeason.name : '';
          } else if (newValue.seasons_v2) {
            this.nameSeasonSelected = newValue.seasons_v2[selectedSeason.id];
          } else if (newValue.seasons && newValue.seasons[selectedSeason.id]) {
            this.nameSeasonSelected = newValue.seasons[selectedSeason.id].alt_name;
          }
        }
      },
    },
    seasons() {
      if (this.player) {
        if (this.player.seasons_v2) {
          const selectedSeason = this.seasons.find(season => season.id === this.seasonId);
          if (this.isPlayerNationalTeam) {
            this.nameSeasonSelected = this.player.national_seasons[selectedSeason.id];
          } else {
            this.nameSeasonSelected = this.player.seasons_v2[selectedSeason.id];
          }
        }
      }
    },
    seasonId() {
      if (this.player) {
        if (this.player.seasons_v2) {
          const selectedSeason = this.seasons.find(season => season.id === this.seasonId);
          if (this.isPlayerNationalTeam) {
            this.nameSeasonSelected = this.player.national_seasons[selectedSeason.id];
          } else {
            this.nameSeasonSelected = this.player.seasons_v2[selectedSeason.id];
          }
        }
      }
    },
  },
  mixins: [playerHeaderMixin],
};
</script>
<style lang="scss">
.title-320-header {
  font-family: 'Avenir-Regular' !important;
}
.subtitle-320-header {
  font-family: 'Avenir-Demi' !important;
}
.header-breadcrumbs-mobile-320 .avenirnextltpro-regular-normal-nevada-16px {
  color: #69707c;
  font-family: 'Avenir-Regular';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}

.header-breadcrumbs-mobile-320 .avenirnextltpro-bold-black-19px {
  color: #000000;
  font-family: 'Avenir-Bold';
  font-size: 19px;
  font-style: normal;
  font-weight: 700;
}

.header-breadcrumbs-mobile-320 .avenirnextltpro-regular-normal-black-32px {
  color: #000000;
  font-family: 'Avenir-Regular';
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
}
.header-breadcrumbs-mobile-320 .screen a {
  display: contents;
  text-decoration: none;
}

.header-breadcrumbs-mobile-320 .valign-text-middle {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  white-space: pre-line;
  text-align: left;
}
</style>
<style lang="scss">
.header-breadcrumbs-mobile-320 .modal {
  z-index: 60 !important;
  flex-direction: bottom;
  justify-content: bottom;
}
.header-breadcrumbs-mobile-320 .modal-content,
.header-breadcrumbs-mobile-320 .modal-card {
  position: absolute;
  bottom: 0;
  // @media screen and (max-width: 330px) {
  //   height: auto !important;
  //   // margin-top: 50px !important;
  // }
}
.header-breadcrumbs-mobile-320 .lives-modal-container {
  background: white;
  height: auto;
  width: 100%;
  border-radius: 0px;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  overflow-x: hidden;
  margin-top: 0px;
  @media screen and (max-width: 500px) {
    // min-height: 680px;
  }
  @media screen and (max-width: 330px) {
    // min-height: 583px;
  }
}
.header-breadcrumbs-mobile-320 .info-categories-item {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 13px;
  position: relative;
}

.header-breadcrumbs-mobile-320 .nombre {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: -0.16px;
  text-align: left;
  color: #6a707c;
  font-family: 'Avenir-Regular';
}

.header-breadcrumbs-mobile-320 .posicin,
.header-breadcrumbs-mobile-320 .partidos-jugados,
.header-breadcrumbs-mobile-320 .minutos-jugados,
.header-breadcrumbs-mobile-320 .torneo {
  letter-spacing: -0.16px;
  line-height: 16px;
  margin-top: -1px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.header-breadcrumbs-mobile-320 .gignac-andre-pierre-320,
.header-breadcrumbs-mobile-320 .delantero,
.header-breadcrumbs-mobile-320 .number,
.header-breadcrumbs-mobile-320 number-1,
.header-breadcrumbs-mobile-320 .liga-mx-apertura-2022 {
  letter-spacing: -0.19px;
  line-height: 16px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}
.header-breadcrumbs-mobile-320 .modal-player-mobile-sm {
  align-items: center;
  background-color: #ffffff;
  border: 1px none;
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 739px;
  min-width: 321px;
  padding: 22px 20px;
  position: relative;
  @media screen and (max-width: 330px) {
    height: 539px;
  }
}
.header-breadcrumbs-mobile-320 .info-categories-item {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 13px;
  position: relative;
}

.header-breadcrumbs-mobile-320 .modal-player-mobile-sm {
  align-items: center;
  background-color: #ffffff;
  border: 1px none;
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 539px;
  min-width: 321px;
  padding: 22px 20px;
  position: relative;
}

.header-breadcrumbs-mobile-320 .info-container {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  // gap: 20px;
  position: relative;
}

.header-breadcrumbs-mobile-320 .title {
  letter-spacing: -0.32px;
  line-height: 28px;
  margin-top: -1px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
  margin-bottom: 0.5em !important;
}

.header-breadcrumbs-mobile-320 .info-categories {
  align-items: flex-start;
  align-self: stretch;
  border: 1px solid;
  border-color: #d9d9d9;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px 16px;
  position: relative;
}

.header-breadcrumbs-mobile-320 .horizontal-div {
  align-self: stretch;
  height: 1px;
  min-width: 249px;
  object-fit: cover;
  position: relative;
}

.header-breadcrumbs-mobile-320 .close-btn {
  align-items: center;
  background-color: #caee6b;
  border: 1px solid;
  border-radius: 12px;
  display: flex;
  gap: 7px;
  justify-content: center;
  padding: 12px 32px;
  position: relative;
  width: 136px;
}

.header-breadcrumbs-mobile-320 .acertar {
  color: #2b3e4d;
  font-family: 'Heebo';
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 18px;
  margin-top: -1px;
  position: relative;
  text-align: center;
  white-space: nowrap;
  width: fit-content;
}
</style>
